





import Vue from 'vue';
import Component from 'vue-class-component';
import { Doughnut, mixins } from 'vue-chartjs-typescript';
import { Prop } from 'vue-property-decorator';

const { reactiveProp } = mixins;

@Component({
  extends: Doughnut,
  mixins: [reactiveProp],
})
export default class DoughnutChartComponent extends Vue {

  @Prop()
  public chartData: any;

  @Prop({ default: () => (
    {legend: {position: 'right'},
    }) })
  public options!: object;

  public renderChart!: (chartData: any, options: any) => void;

  public mounted() {
    this.renderChart(this.chartData , this.options);
  }

  public fillData(chartData: any, options: any) {
    this.renderChart(chartData , options);
  }

}

